import { createReducer, on } from '@ngrx/store';

import * as MerchantSubscriptionActions from './merchant-subscription.actions';
import { MerchantSubscription } from '../../../core/domain/merchant-subscription/merchant-subscription';
import { FormMode, IFormMode } from '../../types/IFormMode';

export interface MerchantSubscriptionState {
  isModalOpen: boolean;
  formMode?: IFormMode;
  merchantId?: string;
  openedMerchantSubscription?: MerchantSubscription;
}

export const initialState: MerchantSubscriptionState = {
  isModalOpen: false,
  formMode: undefined,
  merchantId: undefined,
  openedMerchantSubscription: undefined,
};

export const merchantSubscriptionReducer = createReducer(
  initialState,

  on(
    MerchantSubscriptionActions.openMerchantSubscriptionModal,
    (state, action) => ({
      ...state,
      isModalOpen: true,
      formMode: action.mode,
      merchantId: action.merchantId,
      openedMerchantSubscription: action.merchantSubscription || undefined,
    })
  ),
  on(MerchantSubscriptionActions.closeMerchantSubscriptionModal, (state) => ({
    ...state,
    isModalOpen: false,
    formMode: undefined,
    merchantId: undefined,
    openedMerchantSubscription: undefined,
  }))
);
